enum LocalCurrency {
  CAD = 'CAD',
  USD = 'USD',
}

export default LocalCurrency;
